import { canv } from "@/canv/global";
import type { ElementBase } from "@/elementBase";
import { EmojiWidget } from "@/elements/emoji";
import { renderEmojiToCanvas } from "@/elements/emoji/utils";
import { ImageWidget } from "@/elements/image";
import { Group } from "@/group";
import { toolBase } from "@/tools/toolBase";

// Офсеты для центрирования preview эмодзи относительно позиции курсора
const STICKER_PREVIEW_OFFSET_X = -60;
const STICKER_PREVIEW_OFFSET_Y = -70;
const STICKER_PREVIEW_SIZE = 120;

export class MoreStickersTool extends toolBase {
    unselect() {
        if (this.currentSticker) this.currentSticker = null;
        this.currentEmojiSymbol = "";
    }

    createGroup(newElement: ElementBase, pt?: { x: number; y: number }) {
        const newGroup = new Group(true);
        newElement.setParent(newGroup);
        if (pt)
            newElement.translate(
                pt.x - newGroup.startX + STICKER_PREVIEW_OFFSET_X,
                pt.y - newGroup.startY + STICKER_PREVIEW_OFFSET_Y,
            );

        canv.canvasController.addGroup(newGroup);
        canv.eventManager.openRecord();
        canv.eventManager.createBuildEvent("create", newGroup);
        canv.eventManager.closeRecord();
    }

    TryAction(type: string) {
        if (type === "mousedown") {
            const pt = canv.actionManager.getActionPoint();

            if (this.currentSticker) {
                const newElement = new ImageWidget(this.currentSticker.src, 120, 120);
                this.createGroup(newElement, pt);
            }

            if (this.currentEmojiSymbol) {
                const newEmojiItem = new EmojiWidget(
                    this.currentEmojiSymbol,
                    pt.x + STICKER_PREVIEW_OFFSET_X,
                    pt.y + STICKER_PREVIEW_OFFSET_Y,
                );
                this.createGroup(newEmojiItem);
            }
        }

        canv.redraw();
    }

    draw() {
        const pt = canv.actionManager.getActionPoint();

        if (this.currentSticker) {
            canv.ctx.drawImage(
                this.currentSticker,
                pt.x + STICKER_PREVIEW_OFFSET_X,
                pt.y + STICKER_PREVIEW_OFFSET_Y,
                STICKER_PREVIEW_SIZE,
                STICKER_PREVIEW_SIZE,
            );
        }

        if (this.currentEmojiSymbol) {
            renderEmojiToCanvas(
                this.currentEmojiSymbol,
                pt.x + STICKER_PREVIEW_OFFSET_X,
                pt.y + STICKER_PREVIEW_OFFSET_Y,
                STICKER_PREVIEW_SIZE,
                STICKER_PREVIEW_SIZE,
            );
        }
    }

    setUrl(url: string) {
        this.currentSticker = new Image();
        this.currentSticker.src = url;
    }

    setEmoji(emojiSymbol: string) {
        this.currentEmojiSymbol = emojiSymbol;
    }

    name = "moreStickerTool";
    currentSticker: HTMLImageElement | null = null;
    currentEmojiSymbol = "";
}
